export const COMPONENT_ID_DE_29_BOTTOM_SHEET = 'de_29_bottom_sheet';
export const COMPONENT_ID_ANIMATION_SCREEN = 'relationship_intent_animation_screen';
export const COMPONENT_ID_INFO_BOX = 'relationship_intent_info_box';
export const COMPONENT_TYPE_ANIMATION_SCREEN_V1 = 'animation_screen_v1';
export const COMPONENT_TYPE_INFO_BOX_V1 = 'info_box_v1';
export const ACTION_ID_SELECT_AND_SAVE = 'select_and_save';
export const ACTION_ID_SHOW_INFO_BOX = 'show_info_box';
export const ACTION_ID_VIEW_INFO_BOX = 'view_info_box';
export const ACTION_TRIGGER_INFO_BUTTON_TAP = 'info_button_tap';
export const ACTION_TRIGGER_CHOICE_SELECTION = 'choice_selection';
export const DE_29_FIELDS = {
  component_id: COMPONENT_ID_DE_29_BOTTOM_SHEET,
};

export const FEATURE_TRACKING_ID = 'intent';
